import { createContext, useContext, useState, useRef } from 'react';

const MessageContext = createContext();

export function MessageProvider({ children }) {
  const [alarmMessage, setAlarmMessage] = useState(null);
  const messageQueue = useRef([]);
  const [selectedAlertId, setSelectedAlertId] = useState(null);
  const onReceiveCallback = useRef(null); // ✅ 수신 콜백 저장용
  const [triggerReceive, setTriggerReceive] = useState(null);
const [forceOpenModalType, setForceOpenModalType] = useState(null);
  // 새로운 알림 설정
  const setMessage = (newMessage) => {
    if (!alarmMessage) {
      setAlarmMessage(newMessage); // 화면에 즉시 표시
    } else {
      messageQueue.current.push(newMessage); // 큐에 추가
    }

    // ✅ 콜백이 등록되어 있다면 실행
    if (onReceiveCallback.current) {
      onReceiveCallback.current(newMessage);
    }
  };

  // 닫기 처리 시 호출 (다음 알람 꺼내기)
  const closeMessage = () => {
    if (messageQueue.current.length > 0) {
      const next = messageQueue.current.shift();
      setAlarmMessage(next);
    } else {
      setAlarmMessage(null);
    }
    setSelectedAlertId(null);
  };

  // ✅ 외부에서 콜백 등록할 수 있게 제공
  const setReceiveHandler = (callback) => {
    onReceiveCallback.current = callback;
  };

  return (
    <MessageContext.Provider value={{
      alarmMessage,
      setMessage,
      closeMessage,
      setReceiveHandler,
      selectedAlertId,
      setSelectedAlertId,
      triggerReceive,
      setTriggerReceive,
      forceOpenModalType,
      setForceOpenModalType,
    }}>
      {children}
    </MessageContext.Provider>
  );
}

export function useMessage() {
  return useContext(MessageContext);
}
